// Created by: Imran Khan July 2026
import React from "react";
import { formatCurrency } from "./financialYearUtils";

export function DashboardTable({ title, columns, rows }) {
  return (
    <div className="fy-panel">
      {title && <h5 className="fy-panel-title">{title}</h5>}
      <div className="table-responsive">
        <table className="table table-sm fy-table mb-0">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.type || row.label} className={row.type === "Total" ? "fw-bold" : ""}>
                {columns.map((col) => (
                  <td key={col.key}>{row[col.key] ?? 0}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export function StatusList({ title, items }) {
  return (
    <div className="fy-panel">
      {title && <h5 className="fy-panel-title">{title}</h5>}
      <ul className="fy-status-list">
        {items.map((item) => (
          <li key={item.label}>
            <span>{item.label}</span>
            <strong>{item.value}</strong>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function MetricGrid({ title, items }) {
  return (
    <div className="fy-panel">
      {title && <h5 className="fy-panel-title">{title}</h5>}
      <div className="fy-metric-grid">
        {items.map((item) => (
          <div key={item.label} className="fy-metric-item">
            <span>{item.label}</span>
            <strong>{item.value}</strong>
          </div>
        ))}
      </div>
    </div>
  );
}

export function ProgressPanel({ title, progressPercent, completed, total }) {
  // return (
  //   <div className="fy-panel">
  //     {title && <h5 className="fy-panel-title">{title}</h5>}
  //     <div className="fy-progress-wrap">
  //       <div className="d-flex justify-content-between mb-1">
  //         <span>Installation Progress</span>
  //         <strong>{progressPercent}%</strong>
  //       </div>
  //       <div className="fy-progress-bar">
  //         <div className="fy-progress-fill" style={{ width: `${progressPercent}%` }} />
  //       </div>
  //       <small className="text-muted">
  //         Completed Installations: {completed} / Total Installations: {total}
  //       </small>
  //     </div>
  //   </div>
  // );
}

export function QuickSummary({ data }) {
  if (!data) return null;
  const items = [
    ["Total Enquiries", data.totalEnquiries],
    ["Site Visits", data.siteVisits],
    ["Offers Submitted", data.offersSubmitted],
    ["Total Orders", data.totalOrders],
    ["Total Revenue", formatCurrency(data.totalRevenue, "crore")],
    ["Active AMC", data.activeAmc],
    ["Active Warranty", data.activeWarranty],
    ["Installed Lifts", data.installedLifts],
    ["Collections Total", formatCurrency(data.collectionsTotal)],
  ];

  return (
    <div className="fy-panel">
      <h5 className="fy-panel-title">Quick Summary</h5>
      <div className="fy-quick-summary">
        {items.map(([label, value]) => (
          <div key={label} className="fy-quick-item">
            <span>{label}</span>
            <strong>{value ?? 0}</strong>
          </div>
        ))}
      </div>
    </div>
  );
}
